var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "q97ba5fpva"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-864 -108) translate(-1 85)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M20 23H4v-2c0-2.761 2.239-5 5-5h6c2.761 0 5 2.239 5 5v2zm-8-9c-2.144 0-4.124-1.144-5.196-3s-1.072-4.144 0-6C7.876 3.144 9.856 2 12 2c3.314 0 6 2.686 6 6s-2.686 6-6 6z",
    transform: "translate(865 23)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUser);
export default __webpack_public_path__ + "static/media/icons-user.16395786e3e93006d1c33ae35b0db0ba.svg";
export { ForwardRef as ReactComponent };